import { map } from 'rxjs/operators';
import { TECH_CHART_STATE_KEYS } from 'ChartApp/ts/features/tech-chart/constants';
import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';
import { convertNestedStringToBoolean } from 'Angular/utils/state-utils';
import { formFlattenedObject, formFlattenedParamString } from 'Angular/utils/urls';
import { TechChartUrlSerializer } from 'ChartApp/ts/features/tech-chart-page-shared/state/tech-chart.serializer';
import * as i0 from "@angular/core";
import * as i1 from "Angular/services/core/ajax.service";
import * as i2 from "Angular/services/core/urls.service";
export class TechChartAjaxService {
    constructor(ajaxService, urlsService) {
        this.ajaxService = ajaxService;
        this.urlsService = urlsService;
        this.serializedKeys = [];
        this.serializedKeys = TECH_CHART_STATE_KEYS;
    }
    getFlattenedFormData(techChartState) {
        return formFlattenedObject(techChartState, this.serializedKeys, TechChartUrlSerializer);
    }
    getChartInfo(flatTechChartState) {
        const chartDataBaseUrl = this.urlsService.CHARTS.TECH_CHART_DATA.json;
        const postParams = { ...flatTechChartState };
        return this.ajaxService
            .postFormEncodedDataObserveBody(chartDataBaseUrl, postParams)
            .pipe(map((response) => {
            convertNestedStringToBoolean(response);
            return response;
        }));
    }
    /**
     * Get image source url for making a request to the chart generator service.
     *
     * @param _params {TechChartFlatAppState}
     * @param embedType {string}
     */
    getChartEmbedUrl(_params, embedType) {
        const urlExtension = this.urlsService.getUrl(this.urlsService.EMBEDS.TECH_CHART, { mode: embedType });
        const queryParams = this.getChartDataUrlQuery(_params);
        return `${process.env.NODE_BASE_URL}${urlExtension}&${queryParams}`;
    }
    getChartShareUrl(baseShareUrl, techChartState) {
        const data = this.getFlattenedFormData(techChartState);
        return this.ajaxService.postFormEncodedDataObserveBody(baseShareUrl, data);
    }
    getChartDataUrlQuery(techChartFlatAppState) {
        const state = { ...techChartFlatAppState, redesign: true };
        return formFlattenedParamString(state, TECH_CHART_STATE_KEYS, true);
    }
    getChartSaveAsImageUrl(techChartState) {
        const baseUrl = this.urlsService.EMBEDS.SAVE_AS_IMAGE_TECH_CHART;
        const state = { ...techChartState, redesign: true };
        const data = formFlattenedObject(state, TECH_CHART_STATE_KEYS, TechChartUrlSerializer);
        return this.ajaxService.postFormEncodedDataObserveResponse(baseUrl, data);
    }
    getChartDisclosure(techChartState) {
        const url = this.urlsService.DISCLOSURES.TECH_CHART_DISCLOSURE;
        const state = { ...techChartState, redesign: true };
        const data = formFlattenedObject(state, TECH_CHART_STATE_KEYS);
        return this.ajaxService.postFormEncodedDataWithTextObserveResponse(url, data);
    }
    getChartCSVDataFromState(techChartState) {
        const chartDataBaseUrl = this.urlsService.CHARTS.TECH_CHART_DATA.csv;
        const state = { ...techChartState, redesign: true };
        const data = formFlattenedObject(state, this.serializedKeys);
        return this.ajaxService.postFormEncodedDataWithBlobObserveResponse(chartDataBaseUrl, data);
    }
}
TechChartAjaxService.ɵfac = function TechChartAjaxService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || TechChartAjaxService)(i0.ɵɵinject(i1.AjaxService), i0.ɵɵinject(i2.UrlsService)); };
TechChartAjaxService.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: TechChartAjaxService, factory: TechChartAjaxService.ɵfac, providedIn: 'root' });
